// extracted by mini-css-extract-plugin
module.exports =  {"bullet-list":"vovnGzB","bulletList":"vovnGzB"};